import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { TreelistBadgeCellComponent } from './cells/treelist-badge-cell.component';
import { TreelistCheckboxCellComponent } from './cells/treelist-checkbox-cell.component';
import { TreelistCurrencyCellComponent } from './cells/treelist-currency-cell.component';
import { TreelistDateCellComponent } from './cells/treelist-date-cell.component';
import { TreelistTextCellComponent } from './cells/treelist-text-cell.component';
import { TreelistToggleCellComponent } from './cells/treelist-toggle-cell.component';
import { ForecastRxTreelistComponent } from './forecast-rxtreelist.component';
import { TreelistPagerComponent } from './treelist-pager/treelist-pager.component';
import { TreelistCustomCellDirective } from './cells/treelist-custom-cell.directive';
import { ChipModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { KendoSelectFilterModule } from '../kendo-select-filter/kendo-select-filter.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { IconModule } from '../../components/icon/icon.module';

@NgModule({
  declarations: [
    ForecastRxTreelistComponent,
    TreelistPagerComponent,
    TreelistTextCellComponent,
    TreelistCurrencyCellComponent,
    TreelistDateCellComponent,
    TreelistCheckboxCellComponent,
    TreelistBadgeCellComponent,
    TreelistToggleCellComponent,
    TreelistCustomCellDirective,
  ],
  exports: [
    ForecastRxTreelistComponent,
    TreelistCustomCellDirective,
    KendoSelectFilterModule,
  ],
  imports: [
    CommonModule,
    TreeListModule,
    DropDownsModule,
    ChipModule,
    NgbTooltipModule,
    IconModule,
    KendoSelectFilterModule,
  ],
})
export class ForecastRxTreelistModule {}
